import { createFileRoute } from "@tanstack/react-router"
import { GmailConfiguration } from "modules/settings/components/integrations/gmail"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/gmail")({
  component: GmailConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.gmail.title"),
    })
  },
})
